import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export class MachineToMachineStructureDragAndDropHandler {
  machineToMachineStructureDragAndDrop(targetNode) {
    const machineStructureNodeset = getMachineStructureNodeset();
    machineStructureNodeset.machineToMachineDragAndDrop(
      machineStructureNodeset,
      targetNode,
    );
  }
}
